/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * The configuration of the animatic for a reciprocating compressor.
 */
export type AnimaticRecipCompressorConfig = {
  /**
   * Whether the reciprocating compressor is undergoing service.
   */
  isServiceRequired?: boolean | undefined;
  /**
   * Whether the reciprocating compressor is undergoing trim.
   */
  isTrim?: boolean | undefined;
  /**
   * The references used to determine which pistons are on.
   */
  pistonOnRefs: Array<Ref>;
};

/** @internal */
export const AnimaticRecipCompressorConfig$inboundSchema: z.ZodType<
  AnimaticRecipCompressorConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  is_service_required: types.boolean().default(false),
  is_trim: types.boolean().default(false),
  piston_on_refs: z.array(Ref$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "is_service_required": "isServiceRequired",
    "is_trim": "isTrim",
    "piston_on_refs": "pistonOnRefs",
  });
});
/** @internal */
export type AnimaticRecipCompressorConfig$Outbound = {
  is_service_required: boolean;
  is_trim: boolean;
  piston_on_refs: Array<Ref$Outbound>;
};

/** @internal */
export const AnimaticRecipCompressorConfig$outboundSchema: z.ZodType<
  AnimaticRecipCompressorConfig$Outbound,
  z.ZodTypeDef,
  AnimaticRecipCompressorConfig
> = z.object({
  isServiceRequired: z.boolean().default(false),
  isTrim: z.boolean().default(false),
  pistonOnRefs: z.array(Ref$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    isServiceRequired: "is_service_required",
    isTrim: "is_trim",
    pistonOnRefs: "piston_on_refs",
  });
});

export function animaticRecipCompressorConfigToJSON(
  animaticRecipCompressorConfig: AnimaticRecipCompressorConfig,
): string {
  return JSON.stringify(
    AnimaticRecipCompressorConfig$outboundSchema.parse(
      animaticRecipCompressorConfig,
    ),
  );
}
export function animaticRecipCompressorConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticRecipCompressorConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticRecipCompressorConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticRecipCompressorConfig' from JSON`,
  );
}
